import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useNotifications = () => {
  const [isSending, setIsSending] = useState(false);
  const { toast } = useToast();

  const sendNotification = async ({
    to,
    subject,
    html,
    type = 'email',
    phoneNumbers,
    message,
  }: {
    to: string[];
    subject: string;
    html: string;
    type?: 'email' | 'sms' | 'both';
    phoneNumbers?: string[];
    message?: string;
  }) => {
    setIsSending(true);
    try {
      const { data, error } = await supabase.functions.invoke('send-notifications', {
        body: { to, subject, html, type, phoneNumbers, message },
      });

      if (error) throw error;

      toast({
        title: 'Success',
        description: 'Notification sent successfully',
      });

      return data;
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.message,
        variant: 'destructive',
      });
    } finally {
      setIsSending(false);
    }
  };

  return {
    sendNotification,
    isSending,
  };
};